import {BaseDao} from "../BaseDao";
import {ApiHelper} from "../../apiHelper";
import {ConstantMan} from "../../constantMan";
import {Observable} from "rxjs";

export class CustomerDao extends BaseDao {

    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.CUSTOMERS, apiHelper);
    }

    public find(search: Object): Observable<any> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/find';
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'POST', null, search, headers);
    }
}